// seasonHighs/actionCreators.js
import actionTypes from './actionTypes';

//public actions
const requestSeasonHighsGoalsForData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_GOALS_FOR_DATA
});

const seasonHighsGoalsForDataResponse = (success, goalsForData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_GOALS_FOR_RESPONSE,
    payload: {
        success: success,
        goalsForData: goalsForData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsShotsData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_SHOTS_DATA
});

const seasonHighsShotsDataResponse = (success, shotsData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_SHOTS_RESPONSE,
    payload: {
        success: success,
        shotsData: shotsData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsPenaltyMinutesData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PIM_DATA
});

const seasonHighsPenaltyMinutesDataResponse = (success, pimData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PIM_RESPONSE,
    payload: {
        success: success,
        pimData: pimData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsPowerplayGoalsData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PPG_DATA
});

const seasonHighsPowerplayGoalsDataResponse = (success, ppgData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PPG_RESPONSE,
    payload: {
        success: success,
        ppgData: ppgData.data,
        season,
        gameType,
        errors: errors
    }
});


const requestSeasonHighsPlayerGoalsData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PLAYER_GOALS_DATA
});

const seasonHighsPlayerGoalsDataResponse = (success, goalsData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PLAYER_GOALS_RESPONSE,
    payload: {
        success: success,
        playerGoalsData: goalsData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsPlayerAssistsData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PLAYER_ASSISTS_DATA
});

const seasonHighsPlayerAssistsDataResponse = (success, assistsData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PLAYER_ASSISTS_RESPONSE,
    payload: {
        success: success,
        playerAssistsData: assistsData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsPlayerPointsData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PLAYER_POINTS_DATA
});

const seasonHighsPlayerPointsDataResponse = (success, pointsData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PLAYER_POINTS_RESPONSE,
    payload: {
        success: success,
        playerPointsData: pointsData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsPlayerPowerplayGoalsData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PLAYER_PPG_DATA
});

const seasonHighsPlayerPowerplayGoalsDataResponse = (success, playerPPGData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PLAYER_PPG_RESPONSE,
    payload: {
        success: success,
        playerPPGData: playerPPGData.data,
        season,
        gameType,
        errors: errors
    }
});


const requestSeasonHighsPlayerShotsData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PLAYER_SHOTS_DATA
});

const seasonHighsPlayerShotsDataResponse = (success, shotsData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PLAYER_SHOTS_RESPONSE,
    payload: {
        success: success,
        playerShotsData: shotsData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsPlayerPIMData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PLAYER_PIM_DATA
});

const seasonHighsPlayerPIMDataResponse = (success, pimData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PLAYER_PIM_RESPONSE,
    payload: {
        success: success,
        playerPIMData: pimData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsPlayerTOIData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_PLAYER_TOI_DATA
});

const seasonHighsPlayerTOIDataResponse = (success, toiData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_PLAYER_TOI_RESPONSE,
    payload: {
        success: success,
        playerTOIData: toiData.data,
        season,
        gameType,
        errors: errors
    }
});


const requestSeasonHighsGoalieShotsAgainstData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_GOALIE_SHOTS_AGAINST_DATA
});

const seasonHighsGoalieShotsAgainstDataResponse = (success, shotsAgainstData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_GOALIE_SHOTS_AGAINST_RESPONSE,
    payload: {
        success: success,
        goalieShotsAgainstData: shotsAgainstData.data,
        season,
        gameType,
        errors: errors
    }
});

const requestSeasonHighsGoalieSavesData = () => ({
    type: actionTypes.REQUEST_SEASON_HIGHS_GOALIE_SAVES_DATA
});

const seasonHighsGoalieSavesDataResponse = (success, savesData, season, gameType, errors) => ({
    type: actionTypes.SEASON_HIGHS_GOALIE_SAVES_RESPONSE,
    payload: {
        success: success,
        goalieSavesData: savesData.data,
        season,
        gameType,
        errors: errors
    }
});
export default {
    requestSeasonHighsGoalsForData,
    seasonHighsGoalsForDataResponse,
    requestSeasonHighsShotsData,
    seasonHighsShotsDataResponse,
    requestSeasonHighsPenaltyMinutesData,
    seasonHighsPenaltyMinutesDataResponse,
    requestSeasonHighsPowerplayGoalsData,
    seasonHighsPowerplayGoalsDataResponse,

    requestSeasonHighsPlayerGoalsData,
    seasonHighsPlayerGoalsDataResponse,
    requestSeasonHighsPlayerAssistsData,
    seasonHighsPlayerAssistsDataResponse,
    requestSeasonHighsPlayerPointsData,
    seasonHighsPlayerPointsDataResponse,
    requestSeasonHighsPlayerPowerplayGoalsData,
    seasonHighsPlayerPowerplayGoalsDataResponse,
    requestSeasonHighsPlayerShotsData,
    seasonHighsPlayerShotsDataResponse,
    requestSeasonHighsPlayerPIMData,
    seasonHighsPlayerPIMDataResponse,
    requestSeasonHighsPlayerTOIData,
    seasonHighsPlayerTOIDataResponse,

    requestSeasonHighsGoalieShotsAgainstData,
    seasonHighsGoalieShotsAgainstDataResponse,
    requestSeasonHighsGoalieSavesData,
    seasonHighsGoalieSavesDataResponse
};